import { Text } from '@components/Helpers'
import styled from '@emotion/styled'
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Fade,
  Skeleton,
  SkeletonProps,
} from '@mui/material'
import Image from 'next/image'
import { ReactNode } from 'react'

const SkeletonCard = styled(Skeleton)(() => ({
  backgroundColor: 'grey.900',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
  borderRadius: 4,
}))

const Root = styled(Card)({
  background: 'var(--dewi_surface_card) !important',
  backgroundColor: 'var(--dewi_surface_card) !important',
  border: 'none !important',
  borderWidth: 0,
  boxShadow: 'none',
  borderRadius: 'var(--dewi_radius_lg)',
  transition: 'all .2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.03)',
  },
})

const ActionArea = styled(CardActionArea)(() => ({
  position: 'relative',
  display: 'contents',
}))

const CardImage = styled(Image)(() => ({
  width: '100%',
  height: '100%',
  borderRadius: 10,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  opacity: 0,
}))

function DewiCardContent({
  color,
  children,
}: {
  color: string
  children: ReactNode
}) {
  const StyledCardContent = styled(CardContent)(() => ({
    backgroundColor: color,
    paddingTop: 0,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  }))
  return <StyledCardContent>{children}</StyledCardContent>
}

const SkeletonCardWrapper = (props: SkeletonProps) => {
  return (
    <Fade in timeout={1000}>
      <Box>
        <Root>
          <SkeletonCard variant="rectangular" />
          <ActionArea>
            <CardImage alt={''} width={2000} height={2000} src={''} />
            <Fade in={false} timeout={1000}>
              <Box>
                <DewiCardContent color={'transparent'}>
                  <DewiCardText>{''}</DewiCardText>
                </DewiCardContent>
              </Box>
            </Fade>
          </ActionArea>
        </Root>
      </Box>
    </Fade>
  )
}

function DewiCardText({ children }: { children: ReactNode }) {
  const TextContainer = styled(Box)({
    border: 'none',
    backgroundColor: 'transparent',
    borderRadius: 0,
    padding: 10,
  })

  return (
    <TextContainer>
      <Text
        sx={{
          textAlign: 'center',
          fontWeight: 'normal',
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 1,
        }}
      >
        {children}
      </Text>
    </TextContainer>
  )
}

export default SkeletonCardWrapper
